/* Quick add on product cards — ajax add to cart + drawer refresh.
   Delegated: works for every card, including infinite-scroll loads. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nqa-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;

    btn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-nqa-variant'), 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          if (typeof window.PXUTheme.jsAjaxCart.updateView === 'function') window.PXUTheme.jsAjaxCart.updateView();
          if (typeof window.PXUTheme.jsAjaxCart.showDrawer === 'function') window.PXUTheme.jsAjaxCart.showDrawer();
        }
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function () {
        btn.classList.remove('is-adding');
      });
  }, true);

  // ── Size + Length products (two-axis) ──────────────────────────
  // Liquid emits variant data; a length toggle row renders above the
  // sizes. Sizes carry the variant id for the SELECTED length, so the
  // delegated add handler works unchanged. Hydrates lazily on hover
  // (covers infinite-scroll cards too).
  function hydrateTwo(overlay) {
    if (overlay.getAttribute('data-nqa-hydrated')) return;
    var jsonEl = overlay.querySelector('[data-nqa-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    overlay.setAttribute('data-nqa-hydrated', '1');

    var sizeKey = data.sizePos === 1 ? 'o1' : 'o2';
    var lenKey = data.lenPos === 1 ? 'o1' : 'o2';
    var sizes = [], lengths = [];
    data.variants.forEach(function (v) {
      if (sizes.indexOf(v[sizeKey]) === -1) sizes.push(v[sizeKey]);
      if (lengths.indexOf(v[lenKey]) === -1) lengths.push(v[lenKey]);
    });
    function variantFor(size, len) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v[sizeKey] === size && v[lenKey] === len) return v;
      }
      return null;
    }
    var selected = lengths[0];
    for (var i = 0; i < lengths.length; i++) {
      var anyAvail = data.variants.some(function (v) { return v[lenKey] === lengths[i] && v.available; });
      if (anyAvail) { selected = lengths[i]; break; }
    }

    var lenRow = overlay.querySelector('[data-nqa-lengths]');
    var sizeRow = overlay.querySelector('[data-nqa-sizes]');
    function esc(s) { return String(s).replace(/</g, '&lt;'); }
    function render() {
      lenRow.innerHTML = lengths.map(function (l) {
        return '<button type="button" class="nqa-len' + (l === selected ? ' on' : '') + '" data-nqa-len="' + esc(l) + '">' + esc(l) + '</button>';
      }).join('');
      sizeRow.innerHTML = sizes.map(function (s) {
        var v = variantFor(s, selected);
        var label = esc(s);
        return v && v.available
          ? '<button type="button" class="nqa-size" data-nqa-variant="' + v.id + '">' + label + '</button>'
          : '<button type="button" class="nqa-size oos" disabled aria-label="' + label + ' out of stock">' + label + '</button>';
      }).join('');
    }
    render();
    lenRow.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nqa-len]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      selected = b.getAttribute('data-nqa-len');
      render();
    });
  }
  document.addEventListener('mouseover', function (e) {
    var overlay = e.target.closest('.product-wrap');
    if (!overlay) return;
    var two = overlay.querySelector('[data-nqa-two]');
    if (two) hydrateTwo(two);
  }, { passive: true });
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nqa-two]').forEach(hydrateTwo);
  });
  if (document.readyState !== 'loading') {
    document.querySelectorAll('[data-nqa-two]').forEach(hydrateTwo);
  }

  // ── Colour-swatch sync ─────────────────────────────────────────
  // Card swatches (cross-product-swatches.js) swap the card to a SIBLING
  // product in place. The overlay's variant ids must follow, or quick add
  // would add the original colour. rebuild() refetches the selected
  // product's variants and rewrites the chips.
  var productCache = {};
  function fetchProduct(url) {
    var clean = url.split('?')[0];
    if (!productCache[clean]) {
      productCache[clean] = fetch(clean + '.js').then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      });
    }
    return productCache[clean];
  }

  function optionNames(product) {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  function chipHtml(product) {
    if (!product.available) return null;
    var optNames = optionNames(product);
    var onlyDefault = product.variants.length === 1 &&
      (optNames.length === 0 || optNames[0] === 'Title' ||
       (product.variants[0].title || '').indexOf('Default') === 0);
    if (onlyDefault) {
      return '<button type="button" class="nqa-size nqa-size--wide" data-nqa-variant="' +
        product.variants[0].id + '">Add</button>';
    }
    if (optNames.length !== 1 || !/size/i.test(String(optNames[0]))) return null;
    return product.variants.map(function (v) {
      var label = String(v.option1).replace(/</g, '&lt;');
      return v.available
        ? '<button type="button" class="nqa-size" data-nqa-variant="' + v.id + '">' + label + '</button>'
        : '<button type="button" class="nqa-size oos" disabled aria-label="' + label + ' out of stock">' + label + '</button>';
    }).join('');
  }

  // Two-axis (Size + Length) structure for rebuild(); returns overlay inner
  // HTML with the JSON payload, or null when the product isn't two-axis.
  function twoAxisHtml(product) {
    if (!product.available) return null;
    var optNames = optionNames(product);
    if (optNames.length !== 2) return null;
    var sizePos = 0, lenPos = 0;
    optNames.forEach(function (n, i) {
      if (/size/i.test(n)) sizePos = i + 1;
      if (/length/i.test(n)) lenPos = i + 1;
    });
    if (!sizePos || !lenPos) return null;
    var payload = {
      sizePos: sizePos,
      lenPos: lenPos,
      variants: product.variants.map(function (v) {
        return { id: v.id, o1: v.option1, o2: v.option2, available: v.available };
      })
    };
    return '<script type="application/json" data-nqa-json>' +
      JSON.stringify(payload).replace(/</g, '\\u003c') +
      '<\/script><div class="nqa-lengths" data-nqa-lengths></div><div class="nqa-sizes" data-nqa-sizes></div>';
  }

  function rebuild(card, productUrl) {
    if (!card || !productUrl) return;
    var imageContainer = card.querySelector('.image__container') || card.querySelector('.product__imageContainer');
    if (!imageContainer) return;
    fetchProduct(productUrl).then(function (product) {
      var overlay = card.querySelector('[data-nqa]');
      var chips = chipHtml(product);
      var two = chips ? null : twoAxisHtml(product);
      if (!chips && !two) {
        if (overlay) overlay.remove();
        return;
      }
      if (overlay) overlay.remove();
      overlay = document.createElement('div');
      overlay.className = two ? 'nqa nqa--two' : 'nqa';
      overlay.setAttribute('data-nqa', '');
      if (two) {
        overlay.setAttribute('data-nqa-two', '');
        overlay.innerHTML = two;
        hydrateTwo(overlay);
      } else {
        overlay.innerHTML = '<div class="nqa-sizes">' + chips + '</div>';
      }
      imageContainer.appendChild(overlay);
    }).catch(function () { /* leave overlay as-is */ });
  }

  window.NamaQuickAdd = { rebuild: rebuild };
})();
